import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    question: "Qual o prazo de produção e envio?",
    answer:
      "Por serem peças artesanais, o prazo de produção varia de 7 a 15 dias úteis, dependendo da complexidade da peça. Após a produção, o envio é feito em até 3 dias úteis. Você receberá o código de rastreamento por e-mail.",
  },
  {
    question: "Quais são as formas de pagamento?",
    answer:
      "Aceitamos pagamento via Pix (para pagamento à vista) e cartão de crédito em até 3x sem juros pelo PagSeguro. Todas as transações são seguras e criptografadas.",
  },
  {
    question: "Posso trocar ou devolver minha peça?",
    answer:
      "Por se tratar de produção artesanal e sob medida, não realizamos trocas ou devoluções, exceto em caso de defeito de fabricação. Por isso, é importante conferir as medidas antes de finalizar sua compra.",
  },
  {
    question: "Como funciona o envio?",
    answer:
      "O envio é realizado por nós após a finalização da sua peça. Enviamos para todo o Brasil via Correios ou transportadora. O valor do frete é calculado com base no seu CEP e será informado antes da finalização do pedido.",
  },
  {
    question: "Posso comprar pelo WhatsApp?",
    answer:
      "Sim! Você pode entrar em contato pelo nosso WhatsApp para tirar dúvidas, fazer encomendas personalizadas ou finalizar sua compra. Estamos sempre prontas para ajudar!",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="section-padding">
      <div className="container-narrow">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-4">
            Perguntas Frequentes
          </h2>
          <div className="decoration-line max-w-xs mx-auto" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border rounded-xl px-6 data-[state=open]:bg-card"
              >
                <AccordionTrigger className="text-left font-display text-lg font-medium hover:no-underline py-5">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
